"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Today = _interopRequireDefault(require("@material-ui/icons/Today"));

var _ShoppingCart = _interopRequireDefault(require("@material-ui/icons/ShoppingCart"));

var _Hashtag = _interopRequireDefault(require("../../Icons/Hashtag"));

var _LocalShipping = _interopRequireDefault(require("@material-ui/icons/LocalShipping"));

var _Button = _interopRequireDefault(require("../../Button"));

var _Item = _interopRequireDefault(require("../components/Item"));

var ShipmentPane = function ShipmentPane(_ref) {
  var title = _ref.title,
      provider = _ref.provider,
      shipDate = _ref.shipDate,
      trackingNumber = _ref.trackingNumber,
      items = _ref.items,
      onClick = _ref.onClick;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var list = [{
    icon: /*#__PURE__*/_react["default"].createElement(_LocalShipping["default"], {
      fontSize: "small"
    }),
    content: provider
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Today["default"], {
      fontSize: "small"
    }),
    content: shipDate
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_Hashtag["default"], {
      fontSize: "small"
    }),
    content: trackingNumber
  }, {
    icon: /*#__PURE__*/_react["default"].createElement(_ShoppingCart["default"], {
      fontSize: "small"
    }),
    valign: 'top',
    content: items.length > 0 ? items.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement("p", {
        key: index,
        className: "pb-2 truncate"
      }, item.name);
    }) : null
  }];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-8 pr-4"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "px-6 text-lg font-bold truncate text-dark"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-4"
  }, list.map(function (_ref2, index) {
    var icon = _ref2.icon,
        content = _ref2.content,
        rest = (0, _objectWithoutProperties2["default"])(_ref2, ["icon", "content"]);
    return content && /*#__PURE__*/_react["default"].createElement(_Item["default"], (0, _extends2["default"])({}, rest, {
      key: index,
      size: "sm",
      icon: icon
    }), content);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-6"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    size: "sm",
    color: "secondary",
    onClick: onClick,
    className: "w-48 text-sm !text-primary border-none !bg-secondary"
  }, t('sifts.button.trackPackage'))));
};

var _default = ShipmentPane;
exports["default"] = _default;
//# sourceMappingURL=Shipment.js.map